<mat-card class="auth mat-elevation-z">
	<mat-card-header class="flex-column align-items-center">
		<img [src]="'assets/images/auth/mobile.svg' | s3Image" alt="login" />

		<h1 class="v2">{{ translations['n546'] }}</h1>

		<p class="text-body-14px-regular fg-grey text-center m-0">
			{{ translations['n547'] }}
			<span class="text-body-14px-medium">{{ phone }}</span>
		</p>
	</mat-card-header>

	<mat-card-actions class="p-0 m-0">
		<app-button customClass="w-100 h-100" [label]="translations['n337']" (clicked)="onContinue()"></app-button>
	</mat-card-actions>
</mat-card>
